import React, { Component } from "react";
import Slideshow from "./Slideshow";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';
import AnchorLink from 'react-anchor-link-smooth-scroll'

import slide1 from "../../../images/jumbotron/1.jpg";
import slide2 from "../../../images/jumbotron/2.jpg";
import slide3 from "../../../images/jumbotron/3.jpg";
import slide4 from "../../../images/jumbotron/4.jpg";
import slide5 from "../../../images/jumbotron/5.jpeg";


import "./Carousel.css";
const s = {
    container: "screenW screenH dGray col link_col",
    header: "flex1 fCenter fSize2",
    main: "flex8 white",
    footer: "flex1 fCenter"
};
const slides = [slide1, slide2, slide3, slide4, slide5];


export default class Main extends Component {

	render() {

		return (
            <div className={s.container}>
                <div className={s.main}>
                    <Slideshow slides={slides} />
                </div>
				<AnchorLink offset='65' href='#industries_container'>
				<div className="main_title_more">
				    <FontAwesomeIcon icon={faChevronDown} size="2x"/>
				</div>
				</AnchorLink>
            </div>
		)
	}
};
